import { z } from 'zod'

const environmentSchema = z.object({
  VITE_AI_PROMPTS_BASE_URL: z
    .string()
    .trim()
    .url()
    .default('https://cardreplay.com/ai-prompts/v1'),
  VITE_API_BASE_URL: z.string().trim().min(1).default('/api'),
  VITE_MEDIA_PUBLIC_BASE_URL: z
    .string()
    .trim()
    .url()
    .default('https://media.cardreplay.com'),
  VITE_TELEMETRY_ENABLED: z.enum(['true', 'false']).default('false'),
  VITE_TELEMETRY_ENDPOINT: z.preprocess(
    (value) =>
      typeof value === 'string' && value.trim() === '' ? undefined : value,
    z.string().trim().min(1).optional(),
  ),
})

export type AppConfig = Readonly<{
  aiPromptsBaseUrl: string
  apiBaseUrl: string
  mediaPublicBaseUrl: string
  telemetryEnabled: boolean
  telemetryEndpoint: string | null
}>

export function parseAppConfig(
  environment: Record<string, unknown>,
): AppConfig {
  const parsed = environmentSchema.parse(environment)
  if (
    parsed.VITE_TELEMETRY_ENABLED === 'true' &&
    !parsed.VITE_TELEMETRY_ENDPOINT
  ) {
    throw new Error(
      'VITE_TELEMETRY_ENDPOINT is required when telemetry is enabled',
    )
  }

  return Object.freeze({
    aiPromptsBaseUrl: parsed.VITE_AI_PROMPTS_BASE_URL.replace(/\/$/, ''),
    apiBaseUrl: parsed.VITE_API_BASE_URL.replace(/\/$/, ''),
    mediaPublicBaseUrl: parsed.VITE_MEDIA_PUBLIC_BASE_URL.replace(/\/$/, ''),
    telemetryEnabled: parsed.VITE_TELEMETRY_ENABLED === 'true',
    telemetryEndpoint:
      parsed.VITE_TELEMETRY_ENDPOINT?.replace(/\/$/, '') ?? null,
  })
}

export const appConfig = parseAppConfig(import.meta.env)
